module.exports = __webpack_public_path__ + "img/c-games.f90ae4a5.png";